import React from 'react';
import { v4 as uuid } from 'uuid';
import { useSelector, shallowEqual } from 'react-redux';
import { getAllToasts } from './toasts.selectors';
import { Toast } from './components';

export const ToastType = {
    Success: 'success',
    Warning: 'warning',
    Info: 'info',
    Error: 'error'
};
export class ToastObject {
    constructor({ type = ToastType.Success, message = 'testowa wiadomość', dismiss = 5, id } = {}) {
        this.id = id || uuid();
        this.addedAt = new Date();
        this.type = type;
        this.message = message;
        this.dismiss = dismiss;
    }
}
export const Toasts = () => {
    const toasts = useSelector(getAllToasts, shallowEqual);
    return (
        <div className="toast-list">
            {toasts.map((toast) => <Toast key={toast.id} toast={toast} />)}
        </div>
    );
};